export default {
  en: {
    title: 'Clients',
    pageTitle: 'Clients - all clients',
    pageHeader: 'Clients',
    headerViewName: 'All clients',
    entityName: 'Client',
    dataTableColumns: {
      client: 'Client name',
      compliance: 'Compliance',
      reviewState: 'Review status',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'PII',
      labels: 'Labels',
      products: 'Products',
      assignedUsers: 'Assigned',
      policiesApplied: 'Policies applied',
      assessmentComplete: 'Assessment status',
      dateAdded: 'Date added',
      companyNumber: 'Company number',
      country: 'Country',
      managed: 'RL managed',
      initialAssessmentProgress: 'Initial assessment progress',
      lastUpdatedAt: 'Last answer updated',
      sector: 'Sector',
      website: 'Website',
      exemptionsApplied: 'Exemptions applied',
      nonComplianceApplied: 'Non-compliance applied',
      remediationRequests: 'Remediation requests',
      remediationResponses: 'Remediation responses',
      evidence: 'Evidence',
      activeDiscussions: 'Active discussions',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      reassessmentStatus: 'Re-Assessment status',
      reassessmentPreviousCompletedAt: 'Last assessment',
      initialAssessmentCompleteAt: 'Initial assessment complete',
      reassessmentNextDueAt: 'Next re-assessment due',
      latestAssessmentProgressPercentage: 'Assessment progress',
    },
    dataTable: {
      managedLabel: 'RL managed',
      managedDescription: 'This profile has been created and is managed by Risk Ledger.',
      incomplete: 'Incomplete',
      deletedUser: 'Deleted user',
    },
    filterAttributes: {
      searchPlaceholder: 'Search clients...',
      name: 'Name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      product: 'Product',
      lastActiveAt: 'Last answer updated',
      initialAssessmentProgress: 'Initial assessment progress',
      initialAssessmentComplete: 'Assessment status',
      initialAssessmentCompleteTrue: 'is complete',
      initialAssessmentCompleteFalse: 'is not complete',
      initialAssessmentCompleteAt: 'Initial assessment completion date',
      managedTrue: 'is managed',
      managedFalse: 'is not managed',
      percentageCompliance: 'Compliance',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'Holds PII',
      reviewState: 'Review status',
      numPoliciesApplied: 'Number of policies applied',
      createdAt: 'Date added',
      labels: 'Labels',
      sectorID: 'Sector',
      assignedUsers: 'Assigned users',
      numActiveDiscussions: 'Number of active discussions',
      numExemptionsApplied: 'Number of exemptions applied',
      numNonComplianceApplied: 'Number of non compliances applied',
      numRemediationRequests: 'Number of remediation requests',
      numRemediationResponses: 'Number of remediation responses',
      numEvidence: 'Number of evidence',
      assignedToMe: 'Assigned to me',
      assignedToMeTrue: 'is assigned to me',
      assignedToMeFalse: 'is not assigned to me',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      reassessmentStatus: 'Re-Assessment status',
      reassessmentStatusIdle: 'Complete',
      reassessmentStatusDue: 'Due',
      reassessmentStatusOverdue: 'Overdue',
      reassessmentStatusInProgress: 'In progress',
      reassessmentStatusInitialInProgress: 'Initial assessment in progress',
      reassessmentPreviousCompletedAt: 'Last assessment',
      reassessmentNextDueAt: 'Next re-assessment due',
      latestAssessmentProgressPercentage: 'Assessment progress',
    },
    saveModal: {
      title: 'Save a new view',
      save: 'Save view',
      cancel: 'Cancel',
      description:
        'Give your view a name below. Once saved, it will appear in the sidebar for you and your colleagues.',
      placeholder: 'Name of view...',
    },
    deleteModal: {
      title: "Delete view '{0}'?",
      description:
        "Please confirm if you would like to remove the '{0}' view. It will no longer appear in the sidebar for you and your colleagues.",
      delete: 'Delete view',
      cancel: 'Cancel',
      failed: 'Deleting the view failed.',
    },
    placeholders: {
      emptyTitle: 'Clients',
      emptyDescription: 'No connections could be found',
      errorTitle: 'Clients',
      errorDescription: 'Failed fetching connections',
    },
    export: 'Export',
    exportError: 'There was an error attempting to export the current view',
  },
};
